import { useEffect, useState } from 'react';

import { isGoogleMapsLoaded, loadGoogleMaps } from 'utils/GoogleMaps';

export type GoogleMapsStatus = 'loading' | 'ready' | 'failed';

const useGoogleMaps = (): GoogleMapsStatus => {
  const [status, setStatus] = useState<GoogleMapsStatus>(
    isGoogleMapsLoaded() ? 'ready' : 'loading'
  );

  useEffect(() => {
    let active = true;
    loadGoogleMaps()
      .then(() => active && setStatus('ready'))
      .catch(() => active && setStatus('failed'));
    return () => {
      active = false;
    };
  }, []);

  return status;
};

export default useGoogleMaps;
